import React from 'react';
import './footer.scss';
import { ReactComponent as Logo } from '../../../../assets/svg/att-logo.svg';
import { FOOTER_TEXT } from '../security-dashboard.constant';

const Footer: React.FC = () => {
    const footerItems = [
        { id: 'privacy-center', text: "Your privacy center", url: "https://about.att.com/privacy.html" },
        { id: 'terms-of-use', text: "Terms of use", url: "https://www.att.com/legal/terms.attWebsiteTermsOfUse.html" },
        { id: 'accessibility', text: "Accessibility", url: "https://about.att.com/sites/accessibility" },
        { id: 'privacy-choices', text: "Your privacy choices", url: "https://about.att.com/privacy/choices-and-controls.html" },
    ];

    return (
        <div className="footer">
            <div className="footer-items">
                {footerItems.map((item) => (
                    <a key={item.id} className="footer-item" href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.text}
                    </a>
                ))}
            </div>
            <div className="footer-row">
                <div className="footer-text">{FOOTER_TEXT}</div>
                <div className="footer-logo">
                    <Logo />
                </div>
            </div>
        </div>
    );
};

export default Footer;
